export const SCHEDULER_EVENTS = {
  AT_0_HOURS: 'At0Hours',
  AT_6_HOURS: 'At6Hours',
  EVERY_HOUR: 'EveryHour',
  EVERY_45_MINUTES: 'Every45Minutes',
  EVERY_30_MINUTES: 'Every30Minutes',
  EVERY_15_MINUTES: 'Every15Minutes',
  EVERY_MINUTE: 'EveryMinute',
  NEW_YEAR: 'NewYear',
  ENABLE_BY_TIME: 'EnableByTime',
  DISABLE_BY_TIME: 'DisableByTime',
  DISABLE_BY_DAWN: 'DisableByDawn',
  ENABLE_BY_DUSK: 'EnableByDusk',
};

export const EVENTS = [
  {label: 'В 0 часов', value: SCHEDULER_EVENTS.AT_0_HOURS},
  {label: 'В 6 часов', value: SCHEDULER_EVENTS.AT_6_HOURS},
  {label: 'Каждый час', value: SCHEDULER_EVENTS.EVERY_HOUR},
  {label: 'Каждые 45 минут', value: SCHEDULER_EVENTS.EVERY_45_MINUTES},
  {label: 'Каждые полчаса', value: SCHEDULER_EVENTS.EVERY_30_MINUTES},
  {label: 'Каждые 15 минут', value: SCHEDULER_EVENTS.EVERY_15_MINUTES},
  {label: 'Каждую минуту', value: SCHEDULER_EVENTS.EVERY_MINUTE},
  {label: 'Новый год', value: SCHEDULER_EVENTS.NEW_YEAR},
  {label: 'Включение по времени', value: SCHEDULER_EVENTS.ENABLE_BY_TIME},
  {label: 'Выключение по времени', value: SCHEDULER_EVENTS.DISABLE_BY_TIME},
  {label: 'Выключение при восходе', value: SCHEDULER_EVENTS.DISABLE_BY_DAWN},
  {label: 'Включение при закате', value: SCHEDULER_EVENTS.ENABLE_BY_DUSK},
]

export const EFFECT = {
  None: 'None',
  QuarterShutdown: 'QuarterShutdown',
  QuarterStartup: 'QuarterStartup',
  Wheel: 'Wheel',
  DoubleQuarterStartup: 'DoubleQuarterStartup',
  Fan: 'Fan',
  FanWithAcceleration: 'FanWithAcceleration',
  Neon: 'Neon',
  MaximumOneSecond: 'MaximumOneSecond',
  Medusa: 'Medusa',
  Heart: 'Heart',
  ShutdownOneSecond: 'ShutdownOneSecond',
};

export const EFFECTS_BY_QUARTER = [
  {label: 'Выключено', value: EFFECT.None},
  {label: 'Выключение по четвертям', value: EFFECT.QuarterShutdown},
  {label: 'Включение по четвертям', value: EFFECT.QuarterStartup},
  {label: 'Колесо', value: EFFECT.Wheel},
  {label: 'Включение по две четверти', value: EFFECT.DoubleQuarterStartup},
  {label: 'Вентилятор', value: EFFECT.Fan},
  {label: 'Вентилятор с разгоном', value: EFFECT.FanWithAcceleration},
]

export const SIMPLE_EFFECTS = [
  {label: 'Выключено', value: EFFECT.None},
  {label: 'Неон', value: EFFECT.Neon},
  {label: 'На максимум на 1с', value: EFFECT.MaximumOneSecond},
  {label: 'Медуза', value: EFFECT.Medusa},
  {label: 'Сердце', value: EFFECT.Heart},
  {label: 'Выключение на 1с', value: EFFECT.ShutdownOneSecond},
]

export const EFFECT_OPTIONS = [
  ...EFFECTS_BY_QUARTER,
  ...SIMPLE_EFFECTS
];

